import React, { useState } from 'react';
import Icon from '../../../components/dashboard/DashboardIcons';

const Spinner = () => <span className="h-4 w-4 animate-spin rounded-full border-2 border-slate-300 border-t-teal-600" />;

export default function ReportActions({ onExcel, onPdf, onPrint, disabled, testId }) {
  const [busy, setBusy] = useState(null);
  const btnCls = 'flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-700 hover:border-teal-300 disabled:opacity-40 disabled:hover:border-slate-200';

  const run = async (key, fn) => {
    if (!fn || busy) return;
    setBusy(key);
    try { await fn(); } finally { setBusy(null); }
  };

  return (
    <div className="flex flex-wrap gap-2 print:hidden" data-testid={testId}>
      {onExcel && (
        <button onClick={() => run('excel', onExcel)} disabled={disabled || !!busy} className={btnCls} data-testid={`${testId}-excel-btn`}>
          {busy === 'excel' ? <Spinner /> : <Icon name="download" className="w-4 h-4" />} Excel
        </button>
      )}
      {onPdf && (
        <button onClick={() => run('pdf', onPdf)} disabled={disabled || !!busy} className={btnCls} data-testid={`${testId}-pdf-btn`}>
          {busy === 'pdf' ? <><Spinner /> جاري التصدير...</> : <><Icon name="document" className="w-4 h-4" /> PDF</>}
        </button>
      )}
      {onPrint && (
        <button onClick={() => run('print', onPrint)} disabled={disabled || !!busy} className="flex items-center gap-2 rounded-lg bg-[#16233b] px-3 py-2 text-sm font-semibold text-white disabled:opacity-40" data-testid={`${testId}-print-btn`}>
          {busy === 'print' ? <Spinner /> : <Icon name="document" className="w-4 h-4" />} طباعة
        </button>
      )}
    </div>
  );
}
